import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-carousel-settings',
  templateUrl: 'carousel-settings.component.html',
  styleUrls: ['./carousel-settings.component.scss', './_carousel-settings-theme.component.scss']
})
export class CarouselSettingsComponent implements OnInit, OnDestroy {
  surveyEditorService = inject(SurveyEditorService);

  activeQuestion$ = signal(this.surveyEditorService.surveyEditor$().activeQuestion);

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.surveyEditorService.surveyEditor$().questionActivated$.subscribe(() => {
      this.activeQuestion$.set(this.surveyEditorService.surveyEditor$().activeQuestion);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
